import React, { useEffect, useState, useRef, Component } from 'react';
export function useScrollReveal(options = {
  threshold: 0.1,
  rootMargin: '-50px'
}) {
  const ref = useRef<HTMLElement | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const element = ref.current;
    if (!element) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.unobserve(element);
      }
    }, options);
    observer.observe(element);
    return () => {
      if (element) observer.unobserve(element);
    };
  }, [options.threshold, options.rootMargin]);
  return {
    ref,
    isVisible
  };
}
interface ScrollRevealProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  direction?: 'up' | 'in' | 'left';
  as?: React.ElementType;
}
export function ScrollReveal({
  children,
  className = '',
  delay = 0,
  direction = 'up',
  as: Component = 'div'
}: ScrollRevealProps) {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  const animationClass = `scroll-fade-${direction}`;
  const staggerClass = delay > 0 ? `stagger-${Math.min(delay, 8)}` : '';
  const visibleClass = isVisible ? 'is-visible' : '';
  return <Component ref={ref as any} className={`${animationClass} ${staggerClass} ${visibleClass} ${className}`} data-id="element-311">
      {children}
    </Component>;
}